import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  Box,
  Image,
} from "@chakra-ui/react";

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  alt?: string;
}

const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  alt = "Fullscreen image",
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full" isCentered>
      <ModalOverlay bg="blackAlpha.900" />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        maxW="100vw"
        maxH="100vh"
        m={0}
        p={0}
      >
        <ModalCloseButton
          color="white"
          position="fixed"
          top={4}
          right={4}
          zIndex={2}
        />
        <Box
          position="relative"
          width="100vw"
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={imageUrl}
            alt={alt}
            maxW="100%"
            maxH="100%"
            objectFit="contain"
            onClick={onClose}
            cursor="pointer"
          />
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default ImageModal;
